/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Load_MoreInputs */

const en_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const fr_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const de_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const it_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const ru_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const es_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const zh_cn2_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const ja_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const hi_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const pt_pt2_explorer_search_load_more = /** @type {(inputs: Explorer_Search_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

/**
* | output |
* | --- |
* | "Load More" |
*
* @param {Explorer_Search_Load_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_load_more = /** @type {((inputs?: Explorer_Search_Load_MoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Load_MoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_load_more(inputs)
	if (locale === "de") return de_explorer_search_load_more(inputs)
	if (locale === "it") return it_explorer_search_load_more(inputs)
	if (locale === "ru") return ru_explorer_search_load_more(inputs)
	if (locale === "es") return es_explorer_search_load_more(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_load_more(inputs)
	if (locale === "ja") return ja_explorer_search_load_more(inputs)
	if (locale === "hi") return hi_explorer_search_load_more(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_load_more(inputs)
	return en_explorer_search_load_more(inputs)
});